import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function Modal({
  isOpen,
  onClose,
  title,
  children
}: ModalProps) {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);
  return <AnimatePresence data-id="element-273">
      {isOpen && <>
          {/* Backdrop */}
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={onClose} className="fixed inset-0 bg-black bg-opacity-80 z-50" data-id="element-274" />

          {/* Modal */}
          <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} transition={{
        duration: 0.2
      }} className="fixed inset-4 md:inset-8 lg:inset-16 bg-bg-section border border-accent-primary border-opacity-20 rounded-lg z-50 overflow-hidden flex flex-col" data-id="element-275">
            {/* Header */}
            <div className="flex items-center justify-between p-6 border-b border-accent-primary border-opacity-10" data-id="element-276">
              <h2 className="text-2xl md:text-3xl font-bold text-text-primary" data-id="element-277">
                {title}
              </h2>
              <button onClick={onClose} className="p-2 hover:bg-bg-card rounded-lg transition-colors" aria-label="Cerrar" data-id="element-278">
                <XIcon className="h-6 w-6 text-text-secondary" data-id="element-279" />
              </button>
            </div>

            {/* Content */}
            <div className="flex-1 overflow-y-auto p-6 md:p-8" data-id="element-280">
              <div className="max-w-4xl mx-auto" data-id="element-281">{children}</div>
            </div>
          </motion.div>
        </>}
    </AnimatePresence>;
}